// extracted by mini-css-extract-plugin
export default {"user":"User_user__q1KrV","name":"User_name__L-ACC"};